import React from 'react';
import styled, { keyframes } from 'styled-components';
import { borderSubtle, canvas, textSecondary, textTertiary, borderDefault } from '../../tokens/colors';
import { brand } from '../../tokens/colors';

// ── Divider ───────────────────────────────────────────────────────────────────

export const Divider = styled.hr`
  border: none;
  border-top: 0.5px solid ${borderSubtle};
  margin: 14px 0;
`;

// ── EmptyState ────────────────────────────────────────────────────────────────

interface EmptyStateProps {
  icon?: string;
  title: string;
  description?: string;
}

const EmptyWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  text-align: center;
  color: ${textTertiary};
`;

const EmptyIcon = styled.div`
  width: 40px; height: 40px;
  border-radius: 50%;
  background: ${canvas};
  border: 0.5px solid ${borderDefault};
  display: flex; align-items: center; justify-content: center;
  font-size: 18px;
  margin-bottom: 12px;
`;

export const EmptyState: React.FC<EmptyStateProps> = ({ icon = '○', title, description }) => (
  <EmptyWrap>
    <EmptyIcon>{icon}</EmptyIcon>
    <p style={{ fontSize: 13, fontWeight: 600, color: textSecondary, marginBottom: 4 }}>{title}</p>
    {description && <p style={{ fontSize: 12, color: textTertiary }}>{description}</p>}
  </EmptyWrap>
);

// ── Spinner ───────────────────────────────────────────────────────────────────

const spin = keyframes`to { transform: rotate(360deg); }`;

const SpinnerEl = styled.span<{ $size: number }>`
  display: inline-block;
  width: ${({ $size }) => $size}px;
  height: ${({ $size }) => $size}px;
  border: ${({ $size }) => $size <= 16 ? 2 : 3}px solid ${borderDefault};
  border-top-color: ${brand};
  border-radius: 50%;
  animation: ${spin} 0.7s linear infinite;
  flex-shrink: 0;
`;

interface SpinnerProps { size?: 'sm' | 'md' | 'lg'; }

const sizeMap = { sm: 14, md: 18, lg: 24 };

export const Spinner: React.FC<SpinnerProps> = ({ size = 'md' }) => (
  <SpinnerEl $size={sizeMap[size]} />
);
